module.exports = __webpack_public_path__ + "static/media/downArrow.a36e51ad.svg";